import "./App.css";
import React, { useCallback, useRef } from "react";
import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import { makeHttpCall } from "./utils/HttpHelper";
import { MtvComponent } from "./components/mtvComponent/MtvComponent";
import MtvComponentHook from "./components/mtvComponent/MtvComponentHook";
import NoSleep from "nosleep.js";

function App() {
  return (
    // <Router>
    //   <Switch>
    //     <Route exact path="/">
    //       <Home />
    //     </Route>
    //   </Switch>
    // </Router>
    <Home />
  );
}

// function useQuery() {
//   const { search } = useLocation();
//   // return React.useMemo(() => new URLSearchParams(search), [search]);
//   return new URLSearchParams(search);
// }

function getUrlParam(paramName) {
  const params = new URLSearchParams(window.location.search);
  return params.get(paramName);
}

function Home() {
  // let query = useQuery();

  const [sessionId, setSessionId] = useState(null);
  const [apiCallRunning, setApiCallRunning] = useState(null);
  const noSleepRef = useRef(null);
  const [overlayVisible, setOverlayVisible] = useState(true); // overlay shows initially
  const [enabledUI, setEnabledUI] = useState(false); // UI status

  let event_id = 436;
  const qsWnusId = getUrlParam("wnus");
  const feedback = getUrlParam("feedback");

  const setupUser = useCallback(async () => {
    let cookie_expires = 14;

    var headers = new Headers();
    let email = qsWnusId + "@dercampus.eu";
    headers.append("Authorization", "Basic " + btoa("m-events:kims"));
    const response = await fetch(
      `https://api-lb.virtual-meeting.net/v1/logins/user_logins.json?event_id=${event_id}&email=${email}`,
      { headers: headers, method: "POST" },
    );
    const res = await response.json();
    console.log(res);
    window.Cookies.set("webinar_access_token", res.access_token, {
      expires: cookie_expires,
    });
    window.Cookies.set("access_token", res.access_token, {
      expires: cookie_expires,
    });
    window.Cookies.set("user_id", res.user_id, {
      expires: cookie_expires,
    });
    window.Cookies.set("email", email || "", { expires: cookie_expires });
    window.Cookies.set("lastname", "", { expires: cookie_expires });
    window.Cookies.set("firstname", "", { expires: cookie_expires });
    window.Cookies.set("event_id", res.event_id, {
      expires: cookie_expires,
    });
    if (feedback) {
      window.Cookies.set("external_token", feedback, {
        expires: cookie_expires,
      });
    }
  }, [event_id, qsWnusId]);

  const handleUserGesture = () => {
    if (!noSleepRef.current) return;

    noSleepRef.current.enable(); // enable NoSleep
    setOverlayVisible(false); // hide overlay
    setEnabledUI(true); // update status
    console.log("NoSleep enabled via user gesture!");
  };

  useEffect(() => {
    noSleepRef.current = new NoSleep();

    // Show overlay again if page becomes visible (wake lock may be lost)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setOverlayVisible(true);
        setEnabledUI(false); // optional: show status reset
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const getSessionId = useCallback(
    async (isInitCall) => {
      const getSessionUrl = `https://api-lb.virtual-meeting.net/v1/events/${event_id}/running_and_next_contentsession_id.json?room_id=5977`;
      setApiCallRunning(true);
      const getSession = await makeHttpCall({
        url: getSessionUrl,
        method: "GET",
        isVm: true,
      });

      if (getSession?.ok) {
        //if (String(sessionId) !== String(getSession.data.id))
        {
          //console.log("qwert session Change", sessionId, getSession.data.id)
          setSessionId(getSession.data.id);
        }
      }
      setApiCallRunning(false);
    },
    [event_id],
  );

  useEffect(() => {
    let interval;
    const cleanupFunction = () => clearInterval(interval);
    if (!qsWnusId) return cleanupFunction;
    (async () => {
      await setupUser();
      getSessionId();
      interval = setInterval(() => getSessionId(), 60 * 60 * 1000);
      //interval = setInterval(() => getSessionId(), 10 * 1000);
    })();

    return cleanupFunction;
  }, [getSessionId, setupUser, qsWnusId]);

  if (qsWnusId === null || qsWnusId?.length < 1) {
    return (
      <div className="alert alert-warning message">
        <i className="fas fa-exclamation-circle mr-1"></i> wnus param is missing
      </div>
    );
  }
 if (apiCallRunning === null) {
  return <div>Loading...</div>
}
  if (sessionId === null) {return (
    <div className="alert alert-warning message">
      <i className="fas fa-exclamation-circle mr-1"></i>"We're sorry, but we are
      unable to locate a matching session.
    </div>
  );}


  return (
    <div>
      {overlayVisible && (
        <button
          onClick={handleUserGesture}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9999,
            backgroundColor: "transparent", // invisible
            border: "none",
            cursor: "pointer",
          }}
        />
      )}
      {/* <p>NoSleep enabled: {enabledUI ? "✅ Yes" : "❌ No"}</p> */}
      <MtvComponentHook
        sessionId={sessionId}
        event_id={event_id}
        email={qsWnusId + "@dercampus.eu"}
      />
    </div>
  );
}

export default App;
